export const isSequentialLessonUnlocked = ({
  lessons = [],
  lessonIndex = 0,
  completedLessonIds = [],
  hasAccess = false
} = {}) => {
  if (!hasAccess || lessonIndex < 0 || lessonIndex >= lessons.length) return false;
  if (lessonIndex === 0) return true;
  const completed = completedLessonIds instanceof Set
    ? completedLessonIds
    : new Set(completedLessonIds);
  return lessons
    .slice(0, lessonIndex)
    .every((lesson) => completed.has(lesson.lessonId || lesson.id));
};

export const hasCompletedVideoWatch = ({ duration = 0, watchedSeconds = 0, minimumRatio = 0.9 } = {}) => {
  const total = Number(duration);
  const watched = Number(watchedSeconds);
  return total > 0 && watched >= total * minimumRatio;
};
